module.exports = __webpack_public_path__ + "img/close-modal.362acbab.png";